<template>
	<v-dialog v-model="dialogValue" max-width="900px" persistent>
		<DialogPersonalizado :titulo="titulo()" icone="mdi-office-building-outline" @dialogClose="dialogClose">
			<v-row align="center" v-if="loading" justify="center" class="pa-4">
				<v-progress-linear color="primary" indeterminate />
			</v-row>
			<v-row v-if="id">
				<v-col cols="9" sm="10" md="11" class="pt-0 pb-0">
					Chave
					<v-text-field solo placeholder="Chave" v-model="empresa.id" disabled hide-details class="mb-3">
					</v-text-field>
				</v-col>
				<v-col>
					<v-btn text min-width="0" class="pa-0 mt-4" @click="copiarChave()">
						<v-icon color="red"> mdi-content-copy </v-icon>
					</v-btn>
				</v-col>
			</v-row>
			<v-row>
				<v-col class="pt-0 pb-0">
					Razão Social
					<v-text-field
						solo
						placeholder="Razão Social"
						v-model="empresa.razaoSocial"
						hide-details
						class="mb-3"
					/>
				</v-col>
			</v-row>
			<v-row>
				<v-col class="pt-0 pb-0">
					Nome Fantasia
					<v-text-field
						solo
						placeholder="Nome Fantasia"
						v-model="empresa.nomeFantasia"
						hide-details
						class="mb-3"
					/>
				</v-col>
			</v-row>
			<v-row>
				<v-col class="pt-0 pb-0">
					CPF ou CNPJ
					<v-text-field
						solo
						placeholder="CPF ou CNPJ"
						v-model="empresa.cpfCnpj"
						hide-details
						class="mb-3"
						@input="mascaraCpfCnpj = formatarCpfCnpj(empresa.cpfCnpj)"
						v-mask="mascaraCpfCnpj"
					/>
				</v-col>
			</v-row>
			<v-row>
				<v-col class="pt-0 pb-0">
					Telefone
					<v-text-field
						solo
						placeholder="Telefone"
						v-model="empresa.telefone"
						hide-details
						@input="mascaraTelefone = formatarTelefone(empresa.telefone)"
						v-mask="mascaraTelefone"
						class="mb-3"
					/>
				</v-col>
			</v-row>
			<v-row class="mb-2">
				<v-col class="pt-0 pb-0">
					E-mail
					<v-text-field solo placeholder="E-mail" v-model="empresa.email" hide-details />
				</v-col>
			</v-row>
			<v-row>
				<v-col class="pt-0 pb-0" cols="6">
					<template v-if="id">
						<v-checkbox
							:ripple="false"
							label="Ativo?"
							hide-details
							v-model="empresa.ativo"
							readonly
							color="#cc2128"
						></v-checkbox>
					</template>
				</v-col>
			</v-row>
			<v-row v-if="id">
				<!-- <v-col v-if="userAdmin">
					<v-btn class="red--text"  @click="dialogExcluirOpen()" large width="100%"> <v-icon>mdi-delete-outline</v-icon> Excluir </v-btn>
				</v-col> -->
				<v-col>
					<v-btn
						class="red--text"
						@click="dialogConfiguracoesOpen()"
						large
						width="100%"
						left
					>
						<v-icon>mdi-cog-outline</v-icon>Configurações
					</v-btn>
				</v-col>
			</v-row>
			<!-- <v-row>
				<v-col>
					<v-btn class="white--text" @click="salvar()" color="#CC2128" large width="100%"> Salvar </v-btn>
				</v-col>
			</v-row> -->
		</DialogPersonalizado>
		<DialogConfiguracoes :abrirDialog="configuracoes" :id="empresa.id" @dialogClose="dialogConfiguracoesClose" />
		<DialogExcluir
			:abrirDialog="excluir"
			:id="empresa.id"
			@fecharDialog="dialogExcluirClose"
			@fecharTodosDialogs="dialogClose"
		/>
	</v-dialog>
</template>

<script>
import DialogPersonalizado from '../shared/dialogPersonalizado.vue'
import DialogConfiguracoes from './DialogConfiguracoesEmpresa.vue'
import DialogExcluir from './DialogExcluirEmpresa.vue'
import { mapMutations, mapState, mapActions, mapGetters } from 'vuex'

export default {
	props: {
		abrirDialog: Boolean,
		id: String,
	},
	components: {
		DialogPersonalizado,
		DialogConfiguracoes,
		DialogExcluir,
	},
	data() {
		return {
			empresa: {},
			mascaraCpfCnpj: '',
			mascaraTelefone: '',
			loading: false,
			configuracoes: false,
			excluir: false,
		}
	},
	computed: {
		...mapGetters(['userAdmin', 'userMaster']),
		...mapState('usuarios', ['usuario', 'dialog']),
		dialogValue: {
			get() {
				return this.abrirDialog
			},
			set() {
				this.dialogClose()
				this.loadEmpresas()
			},
		},
	},
	methods: {
		...mapMutations('usuarios', ['setDialog']),
		...mapActions('usuarios', ['hideDialog']),

		copiarChave() {
			navigator.clipboard
				.writeText(this.empresa.id)
				.then(() => {
					this.$store.dispatch('showSuccess', 'Chave copiada com sucesso!')
				})
				.catch(() => {
					this.$store.dispatch('showError', 'Erro ao copiar chave!')
				})
		},
		dialogClose() {
			this.empresa = {}
			this.$emit('dialogClose')
			this.loadEmpresas()
		},
		async loadEmpresa() {
			if (this.id) {
				try {
					this.loading = true
					const response = await this.axios.get(`/empresa/${this.id}`)

					this.empresa = response.data.empresa
				} catch (error) {
					this.$store.dispatch('showError', error)
				} finally {
					this.loading = false
				}
			}
		},
		async salvar() {
			if (this.id) {
				this.editar()
			} else {
				this.criar()
			}
		},
		async criar() {
			try {
				this.loading = true
				const response = await this.axios.post('/empresas', {
					razaoSocial: this.empresa.razaoSocial,
					nomeFantasia: this.empresa.nomeFantasia,
					email: this.empresa.email,
					cpfCnpj: this.empresa.cpfCnpj,
					telefone: this.empresa.telefone,
				})

				if (response.status == 204) {
					this.$store.dispatch('showSuccess', 'Empresa cadastrada com sucesso!')
					this.loadEmpresas()
					this.dialogClose()
				}
			} catch (error) {
				this.$store.dispatch('showError', error)
			} finally {
				this.loading = false
			}
		},
		async editar() {
			try {
				this.loading = true
				const response = await this.axios.put(`/empresas/${this.id}`, {
					razaoSocial: this.empresa.razaoSocial,
					nomeFantasia: this.empresa.nomeFantasia,
					email: this.empresa.email,
					cpfCnpj: this.empresa.cpfCnpj,
					telefone: this.empresa.telefone,
					ativo: this.empresa.ativo,
				})

				if (response.status == 204) {
					this.$store.dispatch('showSuccess', 'Empresa cadastrada com sucesso!')
					this.loadEmpresas()
					this.dialogClose()
				}
			} catch (error) {
				this.$store.dispatch('showError', error)
			} finally {
				this.loading = false
			}
		},
		loadEmpresas() {
			this.$emit('loadEmpresas')
		},
		titulo() {
			if (this.id) return 'Editar Empresa'
			else return 'Cadastrar Empresa'
		},
		dialogConfiguracoesOpen() {
			this.configuracoes = true
		},
		dialogConfiguracoesClose() {
			this.configuracoes = false
		},
		dialogExcluirOpen() {
			this.excluir = true
		},
		dialogExcluirClose() {
			this.excluir = false
		},
	},
	watch: {
		dialogValue() {
			this.empresa = {}
			this.loadEmpresa()
		},
	},
}
</script>
